export default __webpack_public_path__ + "static/media/50-paris.552a494c.jpg";